import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardPendingRegistration } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// The screen an applicant reaches while the request is being reviewed. Its guard asks for
// the request itself: here `/v1/me` answers 403 `account-not-linked`, the normal case.
export const registrationStatusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.registrationStatus,
  staticData: { chrome: 'bare' },
  beforeLoad: ({ context, location }) =>
    guardPendingRegistration({ queryClient: context.queryClient, currentPath: location.href }),
  component: lazyRouteComponent(() => import('../pages/registration-status.tsx')),
})
